// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"80":"03d19d66","866":"e72ff9ad"}[chunkId] + ".chunk.js");